import { render, staticRenderFns } from "./GenMetalHome.vue?vue&type=template&id=5b53b4ef&scoped=true&"
import script from "./GenMetalHome.vue?vue&type=script&lang=js&"
export * from "./GenMetalHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b53b4ef",
  null
  
)

export default component.exports